module.exports = __webpack_public_path__ + "static/media/ax.8c34b6d9.webp";